"use client";

import React, { createContext, ReactNode, useState } from "react";

import {
  FlashContextValue,
  FlashMessageValue,
} from "@/TS/Interfaces/global_interfaces";

/**
 * @returns Object - {flashContextValue, setFlashContextValue, useFlashContext}
 * @description value return that {
 *     type: string,
 *     message: string,
 *     position?: string
 * }
 * when u want to use the flash context do this :
 * SetValue({
 *     type: ""
 * })
 */
export const flashContext = createContext<FlashContextValue>(null!);
function FlashContextProvider({
  children,
}: {
  children: ReactNode;
}): ReactNode {
  const [flashContextValue, setFlashContextValue] = useState<FlashMessageValue>(
    {
      type: "",
      message: "",
    },
  );

  const applyFlashContext = (value: FlashMessageValue, timeoutMs?: number) => {
    setFlashContextValue(value);
    if (value) {
      setTimeout(() => {
        setFlashContextValue({ type: "", message: "" });
      }, timeoutMs ?? 5000);
    }
  };

  const vals: FlashContextValue = {
    flashContextValue,
    setFlashContextValue,
    applyFlashContext,
  };

  return <flashContext.Provider value={vals}>{children}</flashContext.Provider>;
}

export default FlashContextProvider;
